export const config = {
  AUTHORITY_URL: "https://login.microsoftonline.com",
  TENANT_ID: "5b973f99-77df-4beb-b27d-aa0c70b8482c",
  CLIENT_ID: "d8a815ff-2d47-4c99-8408-6a4ea8302e34",
  // BASE_URL:"http://10.1.41.137:5000",
  // BASE_URL: "https://aueuintgwqwap04.azurewebsites.net",
  // BASE_URL:"http://localhost:5000",
  BASE_URL: "https://aueusatppawap02.azurewebsites.net",
};
